import { render, staticRenderFns } from "./pageFooter2.vue?vue&type=template&id=0fa2669b"
import script from "./pageFooter2.vue?vue&type=script&lang=js"
export * from "./pageFooter2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports